import { env } from 'common/env'

const { REACT_APP_IS_FOR_RU_MARKET } = env

export const isForRuMarket = REACT_APP_IS_FOR_RU_MARKET
